export default __webpack_public_path__ + "static/media/variation-text-field.3325316a.png";